var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThirdparty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2789_18400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.44043 32.4142H11.5204L24.0004 15.36L36.4804 33.12L46.0804 31.68L39.8404 46.56L8.64043 46.08L1.44043 32.4142Z",
    fill: "#E1D9CB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.9969 0L0.0078125 32.3845L7.65419 48H40.3396L47.9911 32.3846L23.9969 0ZM37.325 31.8812L25.403 15.4881V6.62123L43.7206 31.3442L37.325 31.8812ZM14.6137 36.7521L12.9802 33.4842L23.9971 18.3357L35.014 33.4842L33.3806 36.7521H14.6137ZM22.5911 15.4881L10.6691 31.8811L4.27778 31.3443L22.5911 6.62198V15.4881ZM10.436 34.6834L12.1366 38.0858L8.67409 43.6886L3.99977 34.1428L10.436 34.6834ZM14.5285 39.5641H33.4656L36.9412 45.188H11.0529L14.5285 39.5641ZM35.8575 38.0857L37.5582 34.6834L43.9983 34.1427L39.3205 43.6893L35.8575 38.0857Z",
    fill: "#88837B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2789_18400"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThirdparty);
export default __webpack_public_path__ + "static/media/thirdparty+.47ec9ab98f4a2ff5daefb230617d7804.svg";
export { ForwardRef as ReactComponent };